var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningStatic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12935_37444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.25 7.75V33.5833H38.75V7.75H23.25ZM28.4167 28.4167V12.9167H33.5833V28.4167H28.4167Z",
    fill: "#F2542D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9987 54.2503C29.2104 54.2503 27.4623 53.72 25.9754 52.7265C24.4885 51.733 23.3296 50.3209 22.6453 48.6688C21.9609 47.0166 21.7819 45.1986 22.1308 43.4447C22.4796 41.6908 23.3408 40.0797 24.6053 38.8152C25.8698 37.5507 27.4809 36.6896 29.2348 36.3407C30.9887 35.9919 32.8067 36.1709 34.4588 36.8553C36.1109 37.5396 37.5231 38.6985 38.5166 40.1854C39.5101 41.6723 40.0404 43.4204 40.0404 45.2087C40.0404 47.6067 39.0878 49.9065 37.3921 51.6021C35.6965 53.2977 33.3967 54.2503 30.9987 54.2503ZM30.9987 41.3337C30.2323 41.3337 29.4831 41.5609 28.8459 41.9867C28.2086 42.4125 27.712 43.0177 27.4187 43.7258C27.1254 44.4338 27.0486 45.213 27.1982 45.9646C27.3477 46.7163 27.7167 47.4068 28.2587 47.9487C28.8006 48.4906 29.4911 48.8597 30.2427 49.0092C30.9944 49.1587 31.7735 49.082 32.4816 48.7887C33.1897 48.4954 33.7949 47.9987 34.2206 47.3615C34.6464 46.7243 34.8737 45.9751 34.8737 45.2087C34.8737 44.181 34.4654 43.1953 33.7387 42.4686C33.012 41.7419 32.0264 41.3337 30.9987 41.3337Z",
    fill: "#F2542D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9167 0H18.0833L12.9167 5.16667L5.16667 12.9167L0 18.0833V43.9167L18.0833 62H43.9167L49.0833 56.8333L56.8333 49.0833L62 43.9167V18.0833L43.9167 0ZM56.8333 41.695L41.695 56.8333H20.305L5.16667 41.695V20.305L20.305 5.16667H41.695L56.8333 20.305V41.695Z",
    fill: "#F2542D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12935_37444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningStatic);
export default __webpack_public_path__ + "static/media/warning-static.719f7a82.svg";
export { ForwardRef as ReactComponent };